<template>
	<div class="personal-news-wrapper">
		<div class="news-header">
			<h3 class="section-title">个人动态</h3>
			<span class="news-count">{{ allMessage.length }} 条记录</span>
		</div>

		<div class="timeline-container" v-if="allMessage.length > 0">
			<div class="timeline-item" v-for="(item, index) in displayList" :key="item.id">
				<div class="timeline-dot" :class="getIconType(item.content).class">
					<i :class="getIconType(item.content).icon"></i>
				</div>
				<div class="timeline-content">
					<div class="timeline-card">
						<p class="news-text">{{ item.content }}</p>
						<div class="news-time">
							<i class="el-icon-time"></i>
							{{ item.createTime }}
						</div>
					</div>
				</div>
			</div>
			
			<!-- 加载更多按钮 -->
			<div class="load-more-wrapper" v-if="hasMore">
				<el-button type="text" class="load-more-btn" @click="loadMore">
					<i class="el-icon-arrow-down"></i>
					加载更多
				</el-button>
			</div>
			<div class="no-more" v-else-if="allMessage.length > pageSize">
				已加载全部
			</div>
		</div>

		<div class="empty-state" v-else>
			<i class="el-icon-camera"></i>
			<p>暂无动态记录</p>
		</div>
	</div>
</template>

<script>
	import {
		getSelfLog
	} from "@/api/index.js"
	export default {
		data() {
			return {
				allMessage: [],
				pageSize: 5,
				displayCount: 5
			}
		},
		computed: {
			displayList() {
				return this.allMessage.slice(0, this.displayCount)
			},
			hasMore() {
				return this.displayCount < this.allMessage.length
			}
		},
		methods: {
			getInfo() {
				getSelfLog().then(res => {
					if (res.code == "0000") {
						this.allMessage = res.data
					}
				})
			},
			loadMore() {
				this.displayCount += this.pageSize
			},
			getIconType(content) {
				if (content && content.includes('登录')) {
					return { icon: 'el-icon-user', class: 'dot-login' }
				} else if (content && (content.includes('退出') || content.includes('登出'))) {
					return { icon: 'el-icon-switch-button', class: 'dot-logout' }
				} else if (content && (content.includes('答题') || content.includes('考试') || content.includes('练习'))) {
					return { icon: 'el-icon-edit-outline', class: 'dot-answer' }
				} else {
					return { icon: 'el-icon-document-checked', class: 'dot-default' }
				}
			}
		},
		mounted() {
			this.getInfo()
		}
	}
</script>

<style lang="scss" scoped>
.personal-news-wrapper {
	padding: 0 30px;
}

.news-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 24px;
}

.section-title {
	font-size: 18px;
	color: #303133;
	margin: 0;
	font-weight: 500;
	padding-left: 12px;
	border-left: 3px solid #409EFF;
}

.news-count {
	font-size: 13px;
	color: #909399;
}

.timeline-container {
	position: relative;
	padding-left: 30px;

	&::before {
		content: '';
		position: absolute;
		left: 11px;
		top: 0;
		bottom: 0;
		width: 2px;
		background: #E8ECF0;
	}
}

.timeline-item {
	position: relative;
	padding-bottom: 24px;

	&:last-child {
		padding-bottom: 0;

		.timeline-content::after {
			display: none;
		}
	}
}

.timeline-dot {
	position: absolute;
	left: -30px;
	top: 0;
	width: 24px;
	height: 24px;
	background: #ECF5FF;
	border: 2px solid #409EFF;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;

	i {
		font-size: 12px;
		color: #409EFF;
	}

	// 登录 - 绿色
	&.dot-login {
		background: #F0F9EB;
		border-color: #67C23A;

		i {
			color: #67C23A;
		}
	}

	// 退出 - 橙色
	&.dot-logout {
		background: #FDF6EC;
		border-color: #E6A23C;

		i {
			color: #E6A23C;
		}
	}

	// 答题 - 蓝色
	&.dot-answer {
		background: #ECF5FF;
		border-color: #409EFF;

		i {
			color: #409EFF;
		}
	}

	// 默认 - 灰色
	&.dot-default {
		background: #F4F4F5;
		border-color: #909399;

		i {
			color: #909399;
		}
	}
}

.timeline-content {
	padding-left: 16px;
}

.timeline-card {
	background: #FAFBFC;
	border-radius: 8px;
	padding: 16px 20px;
	border: 1px solid #EBEEF5;
	transition: all 0.3s ease;

	&:hover {
		background: #F5F7FA;
		border-color: #D4E5F7;
		box-shadow: 0 2px 8px rgba(64, 158, 255, 0.08);
	}
}

.news-text {
	font-size: 14px;
	color: #303133;
	line-height: 1.6;
	margin: 0 0 12px 0;
	word-break: break-all;
}

.news-time {
	font-size: 13px;
	color: #909399;
	display: flex;
	align-items: center;

	i {
		margin-right: 6px;
		font-size: 14px;
	}
}

.empty-state {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 80px 0;
	color: #C0C4CC;

	i {
		font-size: 48px;
		margin-bottom: 16px;
	}

	p {
		font-size: 14px;
		margin: 0;
	}
}

.load-more-wrapper {
	text-align: center;
	padding: 24px 0 10px;
	margin-left: -30px;
}

.load-more-btn {
	color: #409EFF;
	font-size: 14px;
	padding: 12px 40px;
	border-radius: 22px;
	border: 1px solid #409EFF;
	background: #FFFFFF;
	transition: all 0.3s ease;

	i {
		margin-right: 8px;
		transition: transform 0.3s ease;
	}

	&:hover {
		background: #409EFF;
		color: #FFFFFF;
		box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);

		i {
			transform: translateY(2px);
		}
	}
}

.no-more {
	text-align: center;
	padding: 20px 0 10px;
	margin-left: -30px;
	color: #C0C4CC;
	font-size: 13px;
}
</style>
